module.exports = __webpack_public_path__ + "img/wave.8b9d5c89.png";